import * as yup from "yup";
import {string} from "yup";
import i18n from "i18next";
class RequestFile {
    constructor({
                    fileId = '',
                    additionalFileExtension = '',
                    additionalFileName = '',
                } = {}) {
        this.fileId = fileId;
        this.additionalFileExtension = additionalFileExtension;
        this.additionalFileName = additionalFileName;
    }

    static getAttributes(filter = null, validationSchema = null ,optionsData = null) {
        const fileIdPlaceholder = i18n.t('formPlaceholder.dragAndDrop');
        const required = i18n.t('validationMessage.fieldRequired');
      
        // const completeSchema = yup.object().shape({
        //     id: string().nullable(),
        //     fileId: string().required(required).nullable().test("is-required", `${required}`, value => {
        //         return value !== "";
        //     }),
        // });

        const attributes = {           
            fileId :{
                'label': 'Lägg till ytterligare underlag',
                'form': {
                    'type':'file',
                    'placeholder': fileIdPlaceholder,
                    'buttonView': false,
                    'skipValidation': true,
                    //'validation': completeSchema.fields.fileId,
                },
                'value': (item) => item.fileId || "",
            },          
        }

        // if (validationSchema === true) {
        //     return completeSchema;
        // }

        return attributes;
    }
}
export default RequestFile;